export default __webpack_public_path__ + "static/media/veronika_xl.9c3e0cc4.jpg";